/**
 * Menu for the Webis application.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/menu.jsx
 * @class Menu
 * @since 0.0.1
 */

import PropTypes from 'prop-types';

// import '../assets/css/menu.scss';

import React from 'react';
import {Link} from 'gatsby';
import nexus from '../images/nexus-dark.svg';
import closeIcon from '../images/close.svg';
import translations from '../lib/translations';
import {getLanguageUrl, removeLanguageUrl} from '../lib/helpers/language-url';
import sectionState from '../globals/sections';

const PURE_MENU = 'pure-menu',
    PURE_MENU_ = PURE_MENU + '-',
    PURE_MENU_LINK = PURE_MENU_ + 'link',
    PURE_MENU_ITEM = PURE_MENU_ + 'item',
    PURE_MENU_LIST = PURE_MENU_ + 'list',
    SELECTED = 'selected',
    PURE_MENU_SELECTED = ' ' + PURE_MENU_ + SELECTED, // with leading space
    MENUPAGES = [
        {
            label: 'ENERGI_WALLET',
            url: '/energi-wallet',
        },
        {
            label: 'ALERTS',
            url: '/alerts',
        },
        {
            label: 'MASTERNODES',
            url: '/masternodes/listing',
            submenus: [
                {
                    title: 'LISTING',
                    url: '/masternodes/listing',
                },
                {
                    title: 'COLLATERAL',
                    url: '/masternodes/collateral',
                    url2: '/masternodes/collateral/deposit',
                    url3: '/masternodes/collateral/withdraw',
                    children: [
                        {title: 'DEPOSIT', url: '/masternodes/collateral/deposit'},
                        {title: 'WITHDRAW', url: '/masternodes/collateral/withdraw'},
                    ],
                },
                {
                    title: 'OPERATIONS',
                    url: '/masternodes/announce',
                    url2: '/masternodes/denounce'
                },
            ],
        },
        {
            label: 'STAKING',
            url: '/staking/analytics',
            submenus: [
                {
                    title: 'STAKING_ANALYTICS',
                    url: '/staking/analytics'
                },
            ]
        },
        {
            label: 'REWARD_CALCULATOR',
            url: '/reward-calculator'
        },
        {
            label: 'GEN2_COIN_MIGRATION',
            url: '/coin-migration',
            url2: '/',
            steps: [
                'STEP1_MIGRATION',
                'STEP2_MIGRATION',
                'STEP3_MIGRATION',
            ],
        },
        {
            label: 'TREASURY_BUDGET',
            url: '/treasury-budget',
            sections: [
                'DASHBOARD',
                'PROPOSALS',
                'PROPOSAL_VOTING',
                'CREATE_PROPOSAL',
            ]
        },
    ];

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            menu: '',
            submenu: '',
            childmenu: '',
            openSection: ''
        };
        this.translate = translations.init(props);
        this.changeSection = this.changeSection.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        const data = sectionState.$section;
        data.watch(state => this.changeSection(state));

        const props = this.props;
        let path = removeLanguageUrl(props.langInfo, props.location.pathname);
        if ((path !== '/') && path.endsWith('/')) {
            path = path.substr(0, path.length - 1);
        }
        MENUPAGES.map(menupage => {
            const subjects = menupage.submenus || [];
            const href = menupage.url,
                href2 = menupage.url2;
            if (path === href || path === href2 || subjects.find(item => item.url === path)
                || subjects.find(item => item.url2 === path) || subjects.find(item => item.url3 === path)) {
                this.setState({menu: menupage.label});
            }
            if (subjects) {
                subjects.map(submenupage => {
                    const subjects = submenupage.children || [];
                    const href = submenupage.url;
                    if (path === href || subjects.find(item => item.url === path)) {
                        this.setState({submenu: submenupage.title});
                    }
                    if (subjects) {
                        subjects.map(childmenupage => {
                            const subjects = childmenupage.children || [];
                            const href = childmenupage.url;
                            if (path === href || subjects.find(item => item.url === path)) {
                                this.setState({childmenu: childmenupage.title});
                            }
                        });
                    }
                });
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    changeSection(value) {
        if (this._isMounted) {
            this.setState({openSection: value.section});
        }
    }

    decideClass(value) {
        if (this.state.openSection === value) {
            return 'pure-menu-selected';
        }
    }

    /**
   * Gets the menu items as a list of li elements.
   *
   * @method getMenuItems
   * @return {Array} list with li-elements, each representing a menu item
   * @since 0.0.1
   */
    getMenuItems() {
        const props = this.props,
            translate = this.translate,
            langInfo = props.langInfo;
        let path = removeLanguageUrl(props.langInfo, props.location.pathname);

        if ((path !== '/') && path.endsWith('/')) {
            path = path.substr(0, path.length - 1);
        }
        return MENUPAGES.map((menupage, i) => {
            let classname = PURE_MENU_ITEM,
                otherClassName;
            const subjects = menupage.submenus ? menupage.submenus : [];
            const href = menupage.url,
                href2 = menupage.url2;
            if (path === href || path === href2 || subjects.find(item => item.url === path) || subjects.find(item => item.url2 === path) || subjects.find(item => item.url3 === path)) {
                classname += PURE_MENU_SELECTED;
            }
            if (path === '/treasury-budget') {
                otherClassName = 'sections-menu';
            }
            let step = this.props.step;
            let step1 = this.props.step1,
                step2 = this.props.step2,
                step3 = this.props.step3;
            let step1Class = step
                ? step === 1
                    ? PURE_MENU_SELECTED
                    : step1 === true
                        ? 'done'
                        : null
                : null;
            let step2Class = step
                ? step === 2
                    ? PURE_MENU_SELECTED
                    : step2 === true
                        ? 'done'
                        : null
                : null;
            let step3Class = step
                ? step === 3
                    ? PURE_MENU_SELECTED
                    : step3 === true
                        ? 'done'
                        : null
                : null;

            let submenus;

            if (menupage.steps) {
                submenus = this.state.menu === menupage.label && (
                    <ul className={`submenus ${PURE_MENU_LIST}`}>
                        <li
                            className={`submenu ${PURE_MENU_ITEM} ${step1Class}`}
                            onClick={() => this.props.setStep(1)}>
                            {translate.t(menupage.steps[0], true)}
                        </li>
                        <li
                            className={`submenu ${PURE_MENU_ITEM} ${step2Class}`}
                            onClick={() => this.props.setStep(2)}>
                            {translate.t(menupage.steps[1], true)}
                        </li>
                        <li
                            className={`submenu ${PURE_MENU_ITEM} ${step3Class}`}
                            onClick={() => this.props.setStep(3)}>
                            {translate.t(menupage.steps[2], true)}
                        </li>
                    </ul>
                );
            }
            else if (menupage.sections) {
                submenus = this.state.menu === menupage.label && (
                    <ul className={`submenus ${PURE_MENU_LIST}`}>
                        {menupage.sections.map((text, index) => {
                            return (
                                <li
                                    className={`submenu ${PURE_MENU_ITEM} ${otherClassName} ${this.decideClass(text)}`}
                                    key={index}
                                    onClick={() => sectionState.on.set({section: text, scroll: true})}>
                                    {translate.t(text, true)}
                                </li>
                            );
                        })}
                    </ul>
                );
            }
            else if (menupage.submenus) {
                if (this.state.menu === menupage.label) {
                    let path = removeLanguageUrl(props.langInfo, this.props.location.pathname);

                    submenus = (
                        <ul className="submenus">
                            {menupage.submenus.map((submenu, index) => {
                                let childmenus;
                                if (((this.state.submenu === submenu.title) || (path === submenu.url)) && submenu.children) {
                                    const found = submenu.children.find(child => child.url === path);
                                    if (found) {
                                        childmenus = (
                                            <ul className="submenus">
                                                {submenu.children.map((child, index) => {
                                                    const activeClass = this.state.childmenu === child.title ? PURE_MENU_SELECTED : '';
                                                    return (
                                                        <li
                                                            className={`submenu-other ${activeClass}`}
                                                            key={index}
                                                            onClick={() => this.handleChild(child.title)}>
                                                            <Link className={PURE_MENU_LINK} key={index} to={getLanguageUrl(langInfo, child.url)}>
                                                                {translate.t(child.title, true)}
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        );
                                    }
                                }

                                const activeClass = ((this.state.submenu === submenu.title) || (path === submenu.url) || (path === submenu.url2)) ? PURE_MENU_SELECTED : '';
                                return (
                                    <li
                                        className={`submenu-other ${activeClass}`}
                                        key={index}
                                        onClick={() => this.handleSub(submenu.title)}>
                                        <Link className={PURE_MENU_LINK} key={index} to={getLanguageUrl(langInfo, submenu.url)}>
                                            {translate.t(submenu.title, true)}
                                        </Link>
                                        {childmenus}
                                    </li>
                                );
                            })}
                        </ul>
                    );
                }
            }

            return (
                <li className={classname} key={i}>
                    <Link className={PURE_MENU_LINK} to={getLanguageUrl(langInfo, href)}>
                        {translate.t(menupage.label, true)}
                    </Link>
                    {submenus}
                </li>
            );
        });
    }

    handleSub(data) {
        if (this._isMounted) {
            this.setState({submenu: data});
        }
    }

    handleChild(data) {
        if (this._isMounted) {
            this.setState({childmenu: data});
        }
    }

    /**
   * Gets the core menu as a React Component, filled with all menu items (as li elements).
   *
   * @method getMenu
   * @return {ReactComponent}
   * @since 0.0.1
   */
    getMenu() {
        let menuItems = this.getMenuItems();
        return (
            <div className={PURE_MENU}>
                <ul className={PURE_MENU_LIST}>{menuItems}</ul>
            </div>
        );
    }

    /**
   * React render-method --> renders the Component.
   *
   * @method render
   * @return {ReactComponent}
   * @since 0.0.1
   */
    render() {
        let menu = this.getMenu(),
            open = this.props.open ? 'open' : '',
            dim = this.props.open ? 'active' : '';
        return (
            <>
                <div className="menu pure-u">{menu}</div>
                <div className={`dim ${dim}`} onClick={() => this.props.setOpen(false)} />
                <div className={`mobile-menu ${open} pure-u`}>
                    <div className="mobile-menu-header">
                        <img alt="close icon" className="toggle-menu" onClick={() => this.props.setOpen(false)} src={closeIcon} />
                        <img alt="energi logo" className="logo" src={nexus} />
                    </div>
                    {menu}
                </div>
            </>
        );
    }
}

Menu.propTypes = {
    location: PropTypes.any.isRequired,
};

export default Menu;
